import $ from 'jquery';
import CONSTANT from '../../common/js/_constant';
import {calculators}  from '../../common/js/calculator';
import ppfCalculator from '../ppfCalculator/ppfCalculator';

const retirement = {
    variables :{
        retirementNextButton : '.retirement__buttons--next',
        retirementPrevButton : '.retirement__buttons--prev',
        retirementFormSubmit : '.retirement__forms',
        retirementAnwers: '.retirement__wrapper--answers',
        retirementAmountRupee:'.chli__calculator--label',
        retirementTextPlaceholder: '{amount}',
        retirementTextAmountInput:'.retirement--input',
        retirementTextAmountDetails:'.retirement__input-div',
        retirementTextAnswersButton:'.retirement__answer-buttons--prev',
        retirementDetails:'.retirement__forms--details-1',
        retirementStep : '.retirement__wrapper--step',
        retirementAnswersWrap:'.retirement__graph-details--details',
        retirementgreetingText : '.retirement__answers-greeting',
        retirementAnswersMoney:'.retirement__answers-money',
        retirementAnswerMessage: '.retirement__answers-message',
        retirementInvestTime : '.retirement__answers-investment',
        retirementCorpusCreated:'.retirement__corpus-created',
        retirementMobileSteps:'.retirement__wrapper--mobile-steps',
        age: null,
        name: null,
        mobileNumber: null
    },
    methods : {
        replaceAmountInput : (el)=>{
            const $el = $(el);
            const {retirementTextPlaceholder,retirementTextAmountInput,retirementAmountRupee} = retirement.variables;
            let termInsuranePlaceholderText = retirementTextPlaceholder;
            if($el.hasClass('current-age')){
                termInsuranePlaceholderText = '{currentAge}';
            } else if($el.hasClass('retirement-age')){
                termInsuranePlaceholderText = '{retirementAge}';
            } else if($el.hasClass('monthly-expense')){
                termInsuranePlaceholderText = '{monthlyExpense}';
            }  else if($el.hasClass('accumulated-amount')){
                termInsuranePlaceholderText = '{accumulatedAmount}';
            }  else if($el.hasClass('name')){
                termInsuranePlaceholderText = '{customerName}';
            } else if($el.hasClass('contact')){
                termInsuranePlaceholderText = '{phoneNumber}';
            }
            const investmentInput = $el.find(retirementTextAmountInput).parent().removeClass('d-none').detach();
            const amountText = $el.find(retirementAmountRupee);
            if(retirementAmountRupee.length > 0){
                const replacedTextEl = amountText.html().replace(termInsuranePlaceholderText, investmentInput.prop('outerHTML'));
                amountText.html(replacedTextEl);
                calculators.methods.currencyFormat();
                calculators.methods.onlyNumbers();
                calculators.methods.onlyText();
            }
        },
        handleretirement : (el)=>{
            const $el = $(el);
            const name = $el.find('.retirement__input-div.name').find('input').val();
            const currentAge = $el.find('.retirement__input-div.current-age').find('input').val();
            const retirementAge = ($el.find('.retirement__input-div.retirement-age').find('input').val());
            const monthlyExpenseWithComma = $el.find('.retirement__input-div.monthly-expense').find('input').val();
            const monthlyExpense = ppfCalculator.methods.removeCommas(monthlyExpenseWithComma);
            const accumulatedAmount = ppfCalculator.methods.removeCommas($el.find('.retirement__input-div.accumulated-amount').find('input').val());
            const replcedName = $el.find(retirement.variables.retirementgreetingText ).data('text').replace('{customerName}', `<span class="text-blue-400">${name.split(' ')[0]}</span>`);
            $el.find(retirement.variables. retirementgreetingText).html(replcedName);
            const investmentRate = $el.find('.retirement__forms').data('investment-rate');
            const growthRate = $el.find('.retirement__forms').data('growth-rate');
            let retireValues = retirement.methods.calculateRetirementValues(currentAge, retirementAge, 80,monthlyExpense, accumulatedAmount, growthRate, investmentRate);
            let inflationMonth = (retireValues[0].toFixed(0) < 0) ? 0 : retireValues[0].toFixed(0);
            let perMonth = (retireValues[1].toFixed(0) < 0) ? 0 : retireValues[1].toFixed(0);
            if(perMonth == 0){
                $el.find('.retirement__investment-msg').html(`<span class="text-red-300 font-12 leading-13">Seems Yours Goal is already achieved basis inputs provided. Please recalculate if needed!</span>`);
                $el.find(retirement.variables.retirementAnswerMessage).addClass('opacity-0');
            }else{
                $el.find('.retirement__investment-msg').html(`₹ ${ppfCalculator.methods.formatNumber(perMonth)}/month`);
                $el.find(retirement.variables.retirementAnswerMessage).removeClass('opacity-0');
            }
            const replcedAgeValue = $el.find(retirement.variables.retirementAnswerMessage).data('text').replace('{remainingYears}',retirementAge-currentAge);
            $el.find(retirement.variables.retirementAnswerMessage).html(`${replcedAgeValue}`);
            $el.find('.retirement__div--current-expense').find('span').html(`₹ ${monthlyExpenseWithComma}/month`);
            $el.find('.retirement__div--inflation-expense').find('span').html(`₹ ${ppfCalculator.methods.formatNumber(inflationMonth)}/month`);
        },
        calculateRetirementValues : (currentAge, retirementAge, lifeExpectancy, monthlyExpenses, currentRetirementCorpus, investmentGrowthRate, inflationRate) =>{
                    // Convert percentages to decimals
            let inflationRateDecimal = inflationRate / 100;
            let investmentGrowthRateDecimal = investmentGrowthRate / 100;

            // Calculate the number of years until retirement
            let yearsUntilRetirement = retirementAge - currentAge;

            // Calculate the number of years post-retirement (during which expenses will be needed)
            let yearsPostRetirement = lifeExpectancy - retirementAge;

            // Step 1: Calculate the Inflationary Expense Value using FV formula
            let inflationaryExpenseValue = (monthlyExpenses*12) * Math.pow(1 + inflationRateDecimal, yearsUntilRetirement);

            // Step 2: Calculate the Future Value of required corpus at the retirement age
            let requiredCorpusAtRetirement = inflationaryExpenseValue * (1- Math.pow((1+inflationRateDecimal),-yearsPostRetirement))/inflationRateDecimal;

            // // Step 3: Calculate the additional corpus needed
            // let additionalCorpusNeeded = requiredCorpusAtRetirement - currentRetirementCorpus * Math.pow(1 + investmentGrowthRateDecimal, yearsUntilRetirement);

            // // Step 4: Calculate the recommended monthly investment value using PMT formula
            // let n = yearsUntilRetirement * 12; // Number of periods in months
            // let monthlyInvestment = (investmentGrowthRateDecimal / 12 * additionalCorpusNeeded) / (Math.pow(1 + investmentGrowthRateDecimal / 12, n) - 1);
            let additionalCorpusNeeded = currentRetirementCorpus * Math.pow(1 + investmentGrowthRateDecimal, yearsUntilRetirement);
            const requiredValue = requiredCorpusAtRetirement- additionalCorpusNeeded;
            let pmt = (requiredValue *investmentGrowthRateDecimal /12) / (Math.pow(1 + (investmentGrowthRateDecimal ), yearsUntilRetirement) - 1);
            return [inflationaryExpenseValue/12, pmt];
        },
        requiredValidationOnInput:function(el){
            const $el = $(el);
            $el.find("input").on(CONSTANT.eventsListners.INPUT,function(e){
               // calculators.methods.validateRequiredFields();
                //retirement.methods.validateAllInputFields($el,$el.find("input"));
                this.style.width = this.value.length + "ch";
                if($(this).hasClass('retirement--input-contact')){
                    const mobileValue = $(this).val();
                    if (mobileValue.length > 0 && (!/^[6-9][0-9]*$/.test(mobileValue))) {
                        e.target.value = mobileValue.slice(0, -1);
                    }
                }
            });
        },
        validateAllInputFields : ($el, inputs)=>{
            if(inputs.hasClass('retirement--input-current-age')){
                const $field = $el.find('.retirement--input-current-age');
                if(($field.val() && ($field.val().trim() < 18 || $field.val().trim() >= 60))){
                    $field.parent('.error__active').removeClass('error__active');
                    $field.siblings('.error').remove();
                    const $error = $(`<span class="error">Age must be between 18 to 59</span>`);
                    $field.after($error);
                    $field.parent().addClass('error__active');
                }
            }
            if(inputs.hasClass('retirement--input-retirement-age')){
                const $field = $el.find('.retirement--input-retirement-age');
                if(($field.val() && ($field.val().trim() < 55 || $field.val().trim() > 75))){
                    $field.parent('.error__active').removeClass('error__active');
                    $field.siblings('.error').remove();
                    const $error = $(`<span class="error">Age must be between 55 to 75</span>`);
                    $field.after($error);
                    $field.parent().addClass('error__active');
                }
            }
            if(inputs.hasClass('retirement--input-contact')){
                const $field = $el.find('.retirement--input-contact');
                if($field.val() && !retirement.methods.validatePhoneNumber($field.val())){
                    $field.parent('.error__active').removeClass('error__active');
                    $field.siblings('.error').remove();
                    const $error = $(`<span class="error">Phone Number is not Correct</span>`);
                    $field.after($error);
                    $field.parent().addClass('error__active');
                }
            }
        },
        validatePhoneNumber : (value)=>{
            value = value.replace(/[^0-9]/g, '');
            if (value.length === 10 && /^[6789]\d{9}$/.test(value)) {
                return true;
            } else {
                return false;
            }
        },
        handlePrevNext : (el)=>{
            const $el = $(el);
            const { retirementNextButton ,retirementPrevButton , retirementFormSubmit,retirementAnwers } = retirement.variables;
            $el.find(retirementFormSubmit).on(CONSTANT.eventsListners.SUBMIT,function(e){
                e.preventDefault();
                calculators.methods.validateRequiredFields();
                retirement.methods.validateAllInputFields($el,$el.find("input"));
                const isError = $el.find('.retirement__forms--details-1.active').find('.error__active');
                if(isError.length) {return;}
                const isBack = calculators.methods.handleNextPrev(el,false);
                if(isBack){
                    $el.find(retirementPrevButton).removeClass('d-none');
                }
                else{
                    $el.find(retirementPrevButton).addClass('d-none');
                    $el.find(retirementNextButton).addClass('d-none');
                    $el.find(retirementAnwers).removeClass('d-none');
                    retirement.methods.handleretirement(el);
                }
            });
            $el.find(retirementPrevButton).on(CONSTANT.eventsListners.CLICK,function(){
                const isBack = calculators.methods.handleNextPrev(el,true);
                if(isBack){
                    $el.find(retirementPrevButton).removeClass('d-none');
                }
                else{
                    $el.find(retirementPrevButton).addClass('d-none');
                }
            });
        },
        handleAllInputs:(el)=>{
            const $el = $(el);
            $el.find(retirement.variables.retirementTextAmountDetails).each((idx,details)=>{
                retirement.methods.replaceAmountInput(details);
            });
            $el.find(retirement.variables.retirementTextAnswersButton).on(CONSTANT.eventsListners.CLICK,(e)=>{
                $el.find(retirement.variables.retirementAnwers).addClass('d-none');
                $($el.find(retirement.variables.retirementDetails)[0]).addClass('active');
                $el.find(retirement.variables.retirementStep).removeClass('active');
                $($el.find(retirement.variables.retirementStep)[0]).addClass('active');
                $el.find(retirement.variables.retirementNextButton).removeClass('d-none');
                $el.find(retirement.methods.retirementMobileSteps).find('.retirement__step-text').removeClass('active');
                $($el.find(retirement.methods.retirementMobileSteps).find('.retirement__step-text')[0]).removeClass('active');
            });
        },
        handleDataLayer:(el)=>{
            $(el).find('.retirement__buttons--next').on('click', function(e){

                let calculatorSection=$(this).closest('.retirementCalculator').find('.retirement__wrapper--step.active').find('.retirement__step-text').text();
                let calculatorName=$(this).closest('.retirementCalculator').find('.retirement__wrapper--title').text();
                let container = $(this).closest('.retirementCalculator').find('.retirement__forms--details-1.active');
                if(container){
                  const nameInput = container.find('.retirement__input-div.name input');
                  const contactInput = container.find('.retirement__input-div.contact input');
                  const ageInput = container.find('.retirement__input-div.current-age input');
                  if(nameInput.length) {
                   retirement.variables.name = nameInput.val();
                  }
                  if(contactInput.length) {
                   retirement.variables.mobileNumber = contactInput.val();
                  }
                  if(ageInput.length) {
                   retirement.variables.age = ageInput.val();
                  }
                }
                let obj = retirement.methods.dataLayerObj(e,calculatorName,calculatorSection,retirement.variables.name,retirement.variables.mobileNumber,retirement.variables.age);
                createDataLayer('buttonClick', obj);
            });
            $(el).find('.retirement__buttons--prev').on('click', function(e){
              let calculatorSection=$(this).closest('.retirementCalculator').find('.retirement__wrapper--step.active').find('.retirement__step-text').text();
              let calculatorName=$(this).closest('.retirementCalculator').find('.retirement__wrapper--title').text();
              let obj = retirement.methods.dataLayerObj(e,calculatorName,calculatorSection, null, null, retirement.variables.age);
              createDataLayer('buttonClick', obj);
            });
            $(el).find('.retirement__buttons--answer-next').on('click', function(e){
              let calculatorSection=$(this).closest('.retirementCalculator').find('.retirement__wrapper--step.active').find('.retirement__step-text').text();
              let calculatorName=$(this).closest('.retirementCalculator').find('.retirement__wrapper--title').text();
              let obj = retirement.methods.dataLayerObj(e,calculatorName,calculatorSection,retirement.variables.name,retirement.variables.mobileNumber,retirement.variables.age);
              createDataLayer('buttonClick', obj);
            });
            $(el).find('.retirement__answer-buttons--prev').on('click', function(e){
              let calculatorSection=$(this).closest('.retirementCalculator').find('.retirement__wrapper--step.active').find('.retirement__step-text').text();
              let calculatorName=$(this).closest('.retirementCalculator').find('.retirement__wrapper--title').text();
              let obj = retirement.methods.dataLayerObj(e,calculatorName,calculatorSection);
              createDataLayer('buttonClick', obj);
            });
        },
        dataLayerObj: function (e,name,section,el,mobileNumber,age) {
            let obj = {
                'articleName' : "",
                'blogCategory' : "",
                'blogPageCategory' : "",
                'buttonText' : e.currentTarget.innerText.replace(/\n/g, '').trim(),
                'pageSection' : name.replace(/\n/g, '').trim().concat('_').concat(section).replace(/\n/g, '').trim(),
                'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? window.location.href.includes("blog") ? "Blogs" : window.location.href.substring(window.location.href.indexOf(".com/"), window.location.href.lastIndexOf('/')) === ".com" ? "Home" : "Other Pages" : "Blog Details Page",
                'planOption' : "",
                'productCategory' : document.getElementById('productCategoryName') ? document.getElementById('productCategoryName').value : "",
                'productName' : document.getElementById('productPlanName') ? document.getElementById('productPlanName').value : "",
                'question' : "",
                'source' : "",
                'searchTerm' : "",
                'videoTitle' : "",
                'name' : el || "",
                'mobileNumber' : mobileNumber || "",
                'age' : age || "",
                'bannerName' : "",
                "countryCode" : "+91",
            };
            return obj;
        },
        init : ()=>{
            if($('.retirement').length > 0){
                $('.retirement').each((idx,ele)=>{
                    retirement.methods.handlePrevNext(ele);
                    retirement.methods.handleAllInputs(ele);
                    retirement.methods.requiredValidationOnInput(ele);
                    retirement.methods.handleDataLayer(ele);
                });
            }
        }
    }
};
$(()=>{
    retirement.methods.init();
});
